import { HttpService } from "../index";

export class HistoryService {

    constructor(        
        protected httpService: HttpService
    ) {}

    getCalculationHistory(calcuationId:string) {
        return new Promise<any> ((resolve, reject) => {
            this.httpService.get('/api/v1/history/' + calcuationId)
                .then((response) => {
                    resolve(response.json());    
                }).catch((error) => {
                    reject(error);
                });
        });        
    }

}


// WEBPACK FOOTER //
// ./src/services/history/history-service.ts